var _path, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoNotDisplayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 18 16",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#c5c5c5",
      strokeWidth: 1.6,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.16002899 7c.74123253-3.55015161 3.96963835-6.22222222 7.83997101-6.22222222 3.8703327 0 7.0987385 2.67207061 7.839971 6.22222222-.7412325 3.5501516-3.9696383 6.2222222-7.839971 6.2222222-3.87033266 0-7.09873848-2.6720706-7.83997101-6.2222222z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 7,
    rx: 2.4,
    ry: 2.333333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.8 14 6.82403312-6.63447665 7.57596688-7.36552335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoNotDisplayIcon);
export default __webpack_public_path__ + "static/media/do_not_display_icon.2a1265c368133e48c378e335c76090f7.svg";
export { ForwardRef as ReactComponent };